import React from 'react';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';

const StatsComponent = () => {
  const stats = [
    {
      value: 500,
      suffix: '+',
      label: 'Completed Projects',
      info: 'Quality craftsmanship in every build',
    },
    {
      value: 20,
      suffix: '+',
      label: 'Years of Experience',
      info: 'Building with expertise & precision',
    },
    {
      value: 95,
      suffix: '%',
      label: 'Client Satisfaction',
      info: 'Trusted by homeowners & businesses',
    },
  ];

  const { ref, inView } = useInView({
    triggerOnce: true, // Animates only once when in view
    threshold: 0.6, // Starts animation when 60% of the component is visible
  });

  return (
    <div className='grid justify-center bg-colour2 py-8 lg:py-16' ref={ref}>
      <ul className='grid md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-6 w-full'>
        {stats.map((stat, index) => (
          <li
            key={index}
            className='relative flex  justify-center items-center p-4 lg:p-6 text-center bg-gradient-to-tl from-colour4 to-colour6 rounded-xl'
          >
            <div className='absolute inset-0 -m-1 rounded-2xl bg-gradient-to-br from-transparent to-colour6 z-[-1]'></div>
            <div className='bg-white w-44 h-auto aspect-square flex flex-col justify-center items-center shadow-2xl rounded-lg p-4 lg:py-8 lg:px-10'>
              <h4 className='text-4xl font-bold text-colour4'>
                {inView ? (
                  <CountUp
                    start={0}
                    end={stat.value}
                    duration={2}
                    suffix={stat.suffix}
                  />
                ) : (
                  '0' + stat.suffix
                )}
              </h4>
              <p className='text-lg font-semibold'>{stat.label}</p>
              <p className='text-sm text-gray-500'>{stat.info}</p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default StatsComponent;
